import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import ScaleText from "react-scale-text";
import "./SnapExamples.css"

const SnapComplexExample = ({ videoSource, lensName, lensLink, lensSnapcode }) => {

    const [isMobile, setIsMobile] = useState(false);

    const handleButtonClick = () => {
        // Call the callback function and pass the videoName
        console.log(lensLink);
        var newTab = window.open();
        newTab.opener = null;
        newTab.location.href = lensLink;
      };


    return (
        <div className="exampleBase">
        <div className='videoBase'>
            <div>
            <video  className='video' src={videoSource} type="video/mp4" autoPlay muted loop playsInline/>
            </div>
            <div  className='snapText'>
            <p className='seP'>{lensName}</p>
            <img className='snapcode' src={lensSnapcode} />
            <br/>

                <button onClick={handleButtonClick} style={{ fontSize: isMobile ? '12px' : '24px' }}> Try </button>
            </div>


        </div>
        </div>
    );
}
  
export default SnapComplexExample;

//                    style={styles.backgroundVideo}